import { render, staticRenderFns } from "./ChartPage.vue?vue&type=template&id=54edec93&"
import script from "./ChartPage.vue?vue&type=script&lang=js&"
export * from "./ChartPage.vue?vue&type=script&lang=js&"
import style0 from "./ChartPage.vue?vue&type=style&index=0&id=54edec93&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports